
import { apiAiRechargeLists } from "@/api/setting";
import { Component, Prop, Vue } from "vue-property-decorator";
import LsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
import LsDialog from "@/components/ls-dialog.vue";
import PromotCommon from "@/components/promot-common.vue";

@Component({
  components: {
    LsDialog,
    LsPagination,
    PromotCommon,
  },
})
export default class AiRechargeLog extends Vue {
  // 分页
  pager: RequestPaging = new RequestPaging();
  apiAiRechargeLists = apiAiRechargeLists;
  searchObj: any = {
    title: "",
    status: "",
  };

  // 获取列表
  getList() {
    this.pager.request({
      callback: apiAiRechargeLists,
      params: this.searchObj,
    });
  }

  created() {
    this.getList();
  }
}
